import Swal from "sweetalert2";

// Reglas de la autorizacion de un cobro con TPV. Son las mismas que revisa el servidor
// (cMultipagosIntenciones::Mtd_RevisarAutorizacionTPV); aqui solo sirven para avisar antes de guardar.
// Se revisaron contra el reporte de Banorte de octubre 2026: las 830 autorizaciones aprobadas tienen
// 6 caracteres (letras o numeros). En la conciliacion aparecieron capturas del folio de la orden y de
// numeros cortos en lugar de la autorizacion.

export const LARGO_AUTORIZACION_TPV = 6;

// Regresa el texto del problema, o "" si la autorizacion se ve bien (o todavia no se captura nada)
export const problemaAutorizacionTPV = (autorizacion, folioOrden) => {
  const a = String(autorizacion || "").trim();
  if (!a) return "";
  if (!/^[A-Za-z0-9]{6}$/.test(a)) {
    return `La autorización de la TPV tiene ${LARGO_AUTORIZACION_TPV} caracteres (letras o números); capturaste ${a.length}. Revisa el número de autorización que imprimió el ticket.`;
  }
  const folio = String(folioOrden || "").trim();
  if (folio && a.toUpperCase() === folio.toUpperCase()) {
    return "Capturaste el folio de la orden. Aquí va el número de autorización que imprimió el ticket de la TPV.";
  }
  return "";
};

// El servidor no guarda una autorizacion TPV que ya esta en otra orden (codigo AUTORIZACION_REPETIDA).
// Se le muestra al cajero en cual y, solo si confirma que es otro cobro, se vuelve a enviar.
//   enviar(confirmada) -> Promise con la respuesta del servidor ya convertida a objeto
// Regresa la respuesta final, o null si el cajero decidio revisar el ticket.
export const enviarConfirmandoRepetida = async (enviar) => {
  const resultado = await enviar(false);
  if (!resultado || resultado.codigo !== "AUTORIZACION_REPETIDA") return resultado;
  const decision = await Swal.fire({
    title: "Autorización ya registrada",
    text: `${resultado.message} ¿Es un cobro distinto con la misma autorización?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, es otro cobro",
    cancelButtonText: "Revisar el ticket",
    confirmButtonColor: "#d9534f",
    // el modal de validacion tiene un z-index alto; la alerta debe quedar encima
    didOpen: () => {
      const cont = document.querySelector(".swal2-container");
      if (cont) cont.style.zIndex = "99999";
    },
  });
  if (!decision.isConfirmed) return null;
  return enviar(true);
};
